import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import {
  FormAlert, FormGroup, handleFormError, InputText, RadioDropdown,
} from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import Button from '@saucelabs/sl-component-buttons';
import validate from '@saucelabs/sl-util-validate';
import { dataCentersList, CURRENT_DC, DEFAULT_DC } from '@saucelabs/sl-util-config';

const SendPasswordResetForm = ({ error, handleSubmit, shouldRenderDCDropdown, submitting }) => (
  <form onSubmit={handleSubmit}>
    <FormAlert type="danger">{error}</FormAlert>
    <Row>
      <Col xs>
        <Field
          className="form-control"
          component={InputText}
          name="username"
          placeholder="Username or email address"
          type="text"
        />
      </Col>
    </Row>
    {shouldRenderDCDropdown && (
      <Row>
        <Col xs>
          <Field
            className="form-control"
            component={RadioDropdown}
            etiquette="Select Data Center Location"
            isInputForm
            label="Data Center"
            name="data_center"
            options={dataCentersList.map((datacenter) => ({
              text: datacenter.label,
              value: datacenter.value,
            }))}
            type="input"
          />
        </Col>
      </Row>
    )}
    <FormGroup>
      <Button
        block
        category="action"
        disabled={submitting}
        type="submit"
      >
          Send Password Reset Email
      </Button>
    </FormGroup>
  </form>
);

SendPasswordResetForm.propTypes = {
  error: PropTypes.any,
  handleSubmit: PropTypes.func.isRequired,
  shouldRenderDCDropdown: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

SendPasswordResetForm.defaultProps = {
  error: undefined,
};

const constraints = {
  username: {
    presence: { allowEmpty: false },
  },
  data_center: {
    presence: { allowEmpty: false },
  },
};

const SendPasswordResetFormWrapper = reduxForm({
  form: 'sendPasswordReset',
  enableReinitialize: true,
  validate: (values) => validate(values, constraints, { format: 'grouped' }),
  onSubmit: (values, dispatch, formProps) => (
    formProps.sendPasswordReset(values)
      .catch(({ response }) => {
        handleFormError({
          dispatch,
          status: response.status,
          errors: {},
          message40x: (
            response.data.errors && response.data.errors.username
          ) || response.data.message,
        });
      })
  ),
})(SendPasswordResetForm);

SendPasswordResetFormWrapper.propTypes = {
  sendPasswordReset: PropTypes.func.isRequired,
};

const mapStateToProps = ({ apps: { auth } }) => ({
  initialValues: {
    // on non-default DC it should always login to the specific DC
    data_center: CURRENT_DC === DEFAULT_DC ? auth.get('latestDataCenter') : CURRENT_DC,
  },
  // render DC dropdown only on main login
  shouldRenderDCDropdown: !!(CURRENT_DC === DEFAULT_DC && dataCentersList.length),
});

const SendPasswordResetFormWrapperContainer = connect(mapStateToProps)(
  SendPasswordResetFormWrapper,
);

export default SendPasswordResetFormWrapperContainer;
export { SendPasswordResetForm, SendPasswordResetFormWrapper, mapStateToProps };
